import { Card, CardBody, Col } from "reactstrap";
import { H3 } from "../../../../AbstractElements";
import { Display, DisplayHeadingTitle } from "../../../../Constants/Constants";
import { DisplayData } from "../../../../Data/UiKits/Typography";
import { dynamicNumber } from "../../../../Utils";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const DisplayHeading = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={DisplayHeadingTitle} tagClass="mb-0" span={DisplayData}/>
        <CardBody className="d-flex flex-column gap-2">
          {dynamicNumber(4).map((item, index) => (
            <H3 key={index} className={`display-${item}`}>
              {Display} {item}
            </H3>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default DisplayHeading;
